import styled from 'styled-components';

import { Flex, IconTrashcanOutline, spaceMixin, token } from '@zillow/constellation';

export const StyledContainer = styled.div`
  align-items: center;
  border-radius: 4px;
  border: 1px solid ${token('colors.gray300')};
  color: ${token('colors.textDark')};
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  min-height: 240px;
  max-height: 311px;
  max-width: 100%;
  padding: ${spaceMixin('sm')};
  text-align: center;
`;

export const StyledIconTrashcanOutline = styled(IconTrashcanOutline)`
  cursor: pointer;

  min-width: 16px;
`;

export const StyledFlex = styled(Flex)`
  overflow: hidden;
`;
